import {
  GET_HISTORICAL_CONTRACTS,
  GET_HISTORICAL_CONTRACTS_ERROR,
  GET_HISTORICAL_CONTRACTS_SUCCESS,
  OPEN_HISTORICAL_CONTRACTS_DIALOG,
  CLOSE_HISTORICAL_CONTRACTS_DIALOG
} from './HistoricalContracts.actions'

const historicalContractsState = {
  error: undefined,
  loading: true,
  contracts: [],
  open: false
}

/**
 * The historical contracts's reducer.
 */
const historicalContractsReducer = (state = historicalContractsState, { payload, type }) => {
  switch (type) {
    case OPEN_HISTORICAL_CONTRACTS_DIALOG: {
      return {
        ...state,
        error: undefined,
        loading: true,
        contracts: [],
        open: true
      }
    }
    case CLOSE_HISTORICAL_CONTRACTS_DIALOG: {
      return {
        ...state,
        error: undefined,
        loading: false,
        contracts: [],
        open: false
      }
    }
    case GET_HISTORICAL_CONTRACTS: {
      return { ...state, loading: true }
    }
    case GET_HISTORICAL_CONTRACTS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_HISTORICAL_CONTRACTS_SUCCESS: {
      return {
        ...state,
        contracts: payload.contracts,
        loading: false,
        open: true
      }
    }
    default: {
      return state
    }
  }
}

export default historicalContractsReducer
